import React, { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import useHttp from '../../../hook/use-http';
import { Chart } from 'react-google-charts';
import NoData_Orion from "./NoData_Orion";
import ChartLoader_Orion from "./ChartLoader_Orion";
import { API_URL_MAIN } from "../../../constants/driveglobalfilterinitalstates";
import BucketsTable_Orion from "./BucketsTable_Orion";
import WaterMark from "../../../componets/Dashboard/DashboardMain/WaterMark";

export default function SingleSoc_Orion({ apiend, gloablfilter, title }) {
  const [chartdata, setChartData] = useState([]);
  const [apiresponce, SetApiResponce] = useState([]);
  const [filteredData, SetfilteredData] = useState([]);
  const { isLoading, error, sendReq: fetchData } = useHttp();
  let modal_title = title;

  const appyData = (data) => {
    const res_result = data;
    let responce = {
      "<100": 0,
      "150": 0,
      "200": 0,
      "250": 0,
      "300": 0,
      ">300": 0,
    };
    if (res_result.length != 0) {
      SetApiResponce(res_result);
      let temp_result = res_result;
      temp_result.map(d => {
        let value = d.median_Range.values["50.0"];
        if (value < 100) {
          responce["<100"] = responce["<100"] + 1;
        } else if (value >= 100 && value < 150) {
          responce["150"] = responce["150"] + 1;
        } else if (value >= 150 && value < 200) {
          responce["200"] = responce["200"] + 1;
        } else if (value >= 200 && value < 250) {
          responce["250"] = responce["250"] + 1;
        } else if (value >= 250 && value < 300) {
          responce["300"] = responce["300"] + 1;
        }
        else if (value >= 300) {
          responce[">300"] = responce[">300"] + 1;
        }
      })
      let res_result_final = [["Element", "Count", { role: "style" }]]
      let loop_keys = Object.keys(responce);
      loop_keys = ["<100", "150", "200", "250", "300", ">300"]
      loop_keys.map(x => {
        // res_result_final.push([x, responce[x], "#83A4CF"]);
        res_result_final.push([x, responce[x], "stroke-width: 1;stroke-color: black;"]);
      })
      setChartData((prestate) => res_result_final);
    } else {
      setChartData((prestate) => []);
    }
  }

  const options = {
    hAxis: {
      gridlines: {
        color: 'transparent'
      },
      title: 'Range(Km)',
      minValue: 0,
      format: 'short',
      direction: 1,
      slantedText: true,
      slantedTextAngle: 90
    },
    vAxis: {
      gridlines: {
        color: 'transparent'
      },
      title: 'Vehicle Count',
      minValue: 0,
      format: 'short',
    },
    bar: { groupWidth: "100%" },
    legend: "none",
    isStacked: false,
    series: {
      0: { color: "#83A4CF" },
    },
  };

  useEffect(() => {
    fetchData({ url: API_URL_MAIN + "orion_drive_api/" + apiend, body: { filterdata: gloablfilter } }, appyData)
  }, [gloablfilter])

  return (
    <>
      <div className="v-title chartbox chartbox_bus">
        {/* <div className="v-title chartbox chartbox_bus"> */}
        <div className="titlebg_orion text-fit">{title}</div>
        <div className="chartHGT">
          <WaterMark />
          {(isLoading) ? <ChartLoader_Orion /> : ((chartdata.length == 0) ? <NoData_Orion /> : <Chart chartType="ColumnChart" width="100%" height="210px" data={chartdata} options={options} chartEvents={[
            {
              eventName: 'select',
              callback: ({ chartWrapper }) => {
                const chart = chartWrapper.getChart()
                const selection = chart.getSelection()
                if (selection.length === 1) {
                  const [selectedItem] = selection;
                  const { row } = selectedItem;

                  // const barvalue = parseInt((chartWrapper.getDataTable().Wf[row].c[0].v));
                  const barvalue = chartWrapper.getDataTable().Wf[row].c[0].v;
                  const count = chartWrapper.getDataTable().Wf[row].c[1].v;
                  if (count != 0) {
                    let filtered_temp = [];
                    filtered_temp = apiresponce.filter(x => {
                      if (x.median_Range.values["50.0"] < barvalue && x.median_Range.values["50.0"] >= barvalue - 25) {
                        return x;
                      }
                      else if (x.median_Range.values["50.0"] >= 300 && barvalue === ">300") {
                        return x
                      }
                      else if (x.median_Range.values["50.0"] < 100 && barvalue === "<100") {
                        return x
                      }
                    })

                    function compareObjects(object1, object2, key) {
                      const obj1 = object1.median_Range.values["50.0"]
                      const obj2 = object2.median_Range.values["50.0"]

                      if (obj1 > obj2) {
                        return -1
                      }
                      if (obj1 < obj2) {
                        return 1
                      }
                      return 0
                    }

                    filtered_temp.sort((value1, value2) => {
                      return compareObjects(value1, value2, 'vehicalId')
                    })

                    SetfilteredData(prestate => filtered_temp);
                    window.$('#exampleModal__' + apiend).modal('show');
                  }
                }
              }
            }
          ]}
          />)}

          <div className="modal fade" id={"exampleModal__" + apiend} tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-lg">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="exampleModalLabel">{modal_title}</h5>
                  <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                </div>
                {/* <div className="modal-body" style={{ overflowY: 'scroll', height: '250px' }}> */}
                <div className="modal-body">
                  {/* <table className="table table-striped">
                    <thead style={{ backgroundColor: '#83A4CF', color: '#fff' }}>
                      <tr>
                        <th scope="col">Vin Number</th>
                        <th scope="col">value</th>
                      </tr></thead>
                    <tbody> */}
                  <BucketsTable_Orion data={filteredData} />
                  {/* </tbody></table> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );

}
